import script from "./QuickKillPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuickKillPanel.vue?vue&type=script&setup=true&lang=ts"

import "./QuickKillPanel.vue?vue&type=style&index=0&id=72fc3ce0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72fc3ce0"]])

export default __exports__